import { ContentLayout7 } from '@components/content/components/content-layout-7/model';
import { ContentLayout8 } from '@components/content/components/content-layout-8/model';
import { CtaLayout1 } from '@components/cta/components/cta-layout-1/model';
import { CtaLayout2 } from '@components/cta/components/cta-layout-2/model';
import { GalleryLayout5 } from '@components/gallery/components/gallery-layout-5/model';
import { HeroLayout3 } from '@components/hero/components/hero-layout-3/model';
import { Partner } from '@components/partner/model';
import { VideoLayout1 } from '@components/video/components/video-layout-1/model';
import { Block, Layout } from '@mock/schema/model';
import { RoutesPath } from '@shared/constants';
import { Page } from '@shared/models/page';

const block: [
  Block<Layout<HeroLayout3>>,
  Block<Layout<CtaLayout1>>,
  Block<Layout<ContentLayout7>>,
  Block<Layout<VideoLayout1>>,
  Block<Layout<ContentLayout8>>,
  Block<Layout<GalleryLayout5>>,
  Block<Partner>,
  Block<Layout<CtaLayout2>>,
  Block<Layout<CtaLayout1>>,
] = [
  {
    type: 'hero',
    data: {
      layout: 'hero_layout3',
      data: {
        title: 'Plus que des projets, nous créons des lieux de vie et des histoires.',
        autoplay: true,
        slidesDesktop: [
          {
            image: {
              link: '/assets/mocks/hero-layout-3/1.jpg',
              alt: 'alt text',
              title: 'image 1',
              gravity: { x: 0.5, y: 0.5, height: 860, width: 1440 },
            },
            link: {
              url: '/',
              label: 'Annecy, 2021 (desktop)',
            },
          },
          {
            image: {
              link: '/assets/mocks/hero-layout-3/1.jpg',
              alt: 'alt text',
              title: 'image 2',
              gravity: { x: 0.5, y: 0.5, height: 860, width: 1440 },
            },
            link: {
              url: '/',
              label: 'Annecy 2, 2021 (desktop)',
            },
          },
          {
            image: {
              link: '/assets/mocks/hero-layout-3/1.jpg',
              alt: 'alt text',
              title: 'image 3',
              gravity: { x: 0.5, y: 0.5, height: 860, width: 1440 },
            },
            link: {
              url: '/',
              label: 'Annecy 3, 2021 (desktop)',
            },
          },
        ],
        slidesMobile: [
          {
            image: {
              link: '/assets/mocks/hero-layout-3/1.jpg',
              alt: 'alt text',
              title: 'image 1',
              gravity: { x: 0.5, y: 0.5, height: 860, width: 1440 },
            },
            link: {
              url: '/',
              label: 'Annecy, 2021 (mobile)',
            },
          },
          {
            image: {
              link: '/assets/mocks/hero-layout-3/1.jpg',
              alt: 'alt text',
              title: 'image 2',
              gravity: { x: 0.5, y: 0.5, height: 860, width: 1440 },
            },
            link: {
              url: '/',
              label: 'Annecy 2, 2021 (mobile)',
            },
          },
          {
            image: {
              link: '/assets/mocks/hero-layout-3/1.jpg',
              alt: 'alt text',
              title: 'image 3',
              gravity: { x: 0.5, y: 0.5, height: 860, width: 1440 },
            },
            link: {
              url: '/',
              label: 'Annecy 3, 2021 (mobile)',
            },
          },
        ],
      },
    },
  },
  {
    type: 'cta',
    data: {
      layout: 'cta_layout1',
      data: {
        text: `Perene dolor sit amet, consectetur adipiscing elit ipsum tortor, adipiscing amet, metus, mi, ac blandit. Cursus quam condimentum sit semper vitae. Dignissim lacus nunc eu viverra in consequat, nisi lacus. Viverra dui sollicitudin feugiat placerat at.`,
        cta: {
          label: 'À propos de Perene',
          url: `/${RoutesPath.ABOUT}`,
        },
        theme: 'CREAM',
      },
    },
  },
  {
    type: 'content',
    data: {
      layout: 'content_layout7',
      data: {
        title: 'valeur',
        items: [
          {
            title: 'Entier',
            text: `Une création intemporelle résulte de la puissance d'une proposition, associée à l'excellence d'un savoir-faire. Votre agenceur Perene met tout en oeuvre pour vous accompagner dans une démarche créative engagée.`,
          },
          {
            title: 'Singulier',
            text: `Perene donne à sa mission une ambition plus grande. Celle d'assumer sa singularité, en ne proposant aucune “collection” ni “modèles”, mais la création d'agencements imaginés pour vous, en partant de votre lieu d'habitation, de votre mode de vie, de vos goûts.`,
          },
          {
            title: 'Inattendu',
            text: `Révéler le potentiel de votre intérieur est la plus belle des valeurs ajoutées. C'est à la fois la promesse et le challenge que s'impose chaque agenceur Perene. Vous surprendre par un parti pris architectural, une astuce dans l'implantation de l'agencement, une association de matières, une combinaison de couleurs...`,
          },
        ],
      },
    },
  },
  {
    type: 'video',
    data: {
      layout: 'video_layout1',
      data: {
        image: {
          title: '',
          alt: 'alt text',
          link: '/assets/mocks/video/1.png',
          gravity: { x: 0.5, y: 0.5, height: 900, width: 1440 },
        },
        mp4Url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4',
      },
    },
  },
  {
    type: 'content_image',
    data: {
      layout: 'content_layout8',
      data: {
        title: `Perene, créateurs d'intérieur.`,
        items: [
          {
            title: `Le sens des couleurs`,
            subtitle: `Un agencement est par essence conçu pour s'intégrer dans une pièce spécifique, avec un volume défini, une surface disponible, une luminosité naturelle incontournable.`,
            text: `Tous ces paramètres vont également orienter le choix des couleurs et de leurs associations. Qu'il s'agisse de l'agencement lui-même ou de la pièce qui va l'accueillir, il est crucial de faire les bons choix.`,
            image: {
              link: '/assets/mocks/content-layout-8/1.jpg',
              alt: 'alt text',
              title: 'image 1',
              gravity: { x: 0.5, y: 0.5, height: 660, width: 588 },
            },
          },
          {
            title: `La décoration`,
            subtitle: `La mise en valeur de votre agencement est intimement liée à la décoration de votre intérieur. Mission pour laquelle votre agenceur peut vous accompagner.`,
            text: `L'art de la décoration réside dans le métissage de styles, les associations inattendues, tout ce qui exprime une vraie personnalité, un supplément d'âme... Il y a quelques règles à maîtriser.`,
            image: {
              link: '/assets/mocks/content-layout-8/2.jpg',
              alt: 'alt text',
              title: 'image 2',
              gravity: { x: 0.5, y: 0.5, height: 660, width: 588 },
            },
          },
          {
            title: `Les matières`,
            subtitle: `Perene travaille la matière sous toutes ses formes. Des plus nobles aux plus simples. Des plus étonnantes aux plus technologiques.`,
            text: `Ce n'est pas tant le luxe des matériaux qui fait la qualité d'une réalisation. C'est avant tout l'art de choisir ceux qui conviendront le mieux à votre projet, de savoir les travailler, les associer, les magnifier, les révéler.`,
            image: {
              link: '/assets/mocks/content-layout-8/3.jpg',
              alt: 'alt text',
              title: 'image 3',
              gravity: { x: 0.5, y: 0.5, height: 660, width: 588 },
            },
          },
        ],
        theme: 'CREAM',
      },
    },
  },
  {
    type: 'gallery',
    data: {
      layout: 'gallery_layout5',
      data: {
        title: `Fiers de nos réalisations.`,
        subtitle: `Nos réalisations`,
        items: [
          {
            image: {
              link: '/assets/mocks/gallery-layout-5/1.jpg',
              alt: 'alt text',
              title: 'image 1',
              gravity: { x: 0.5, y: 0.5, height: 313, width: 486 },
            },
            legend: `<strong>Annecy —</strong> Quand la cuisine joue la carte de l'invisibilité.`,
            url: '/',
          },
          {
            image: {
              link: '/assets/mocks/gallery-layout-5/2.jpg',
              alt: 'alt text',
              title: 'image 2',
              gravity: { x: 0.5, y: 0.5, height: 720, width: 588 },
            },
            legend: `<strong>Aix-les-bains —</strong> Une cuisine-hub pour toute la famille.`,
            url: '/',
          },
          {
            image: {
              link: '/assets/mocks/gallery-layout-5/3.jpg',
              alt: 'alt text',
              title: 'image 3',
              gravity: { x: 0.5, y: 0.5, height: 247, width: 384 },
            },
            legend: `<strong>Arcachon —</strong> Appartement avec vue sur le bassin.`,
            url: '/',
          },
          {
            image: {
              link: '/assets/mocks/gallery-layout-5/4.jpg',
              alt: 'alt text',
              title: 'image 4',
              gravity: { x: 0.5, y: 0.5, height: 576, width: 894 },
            },
            legend: `<strong>Paris 8e —</strong> Les cuisines de l'espace de co-working, au sein de l'Hôtel de la Marine.`,
            url: '/',
          },
          {
            image: {
              link: '/assets/mocks/gallery-layout-5/5.jpg',
              alt: 'alt text',
              title: 'image 5',
              gravity: { x: 0.5, y: 0.5, height: 470, width: 384 },
            },
            legend: `<strong>Caluire —</strong> Lifting ultra contemporain d'une maison.`,
            url: '/',
          },
          {
            image: {
              link: '/assets/mocks/gallery-layout-5/6.jpg',
              alt: 'alt text',
              title: 'image 6',
              gravity: { x: 0.5, y: 0.5, height: 690, width: 444 },
            },
            legend: `<strong>Malmö —</strong> Une cuisine en osmose avec l'histoire du lieu.`,
            url: '/',
          },
        ],
        cta: {
          label: `Toutes les réalisations`,
          url: `/${RoutesPath.PROJECTS}`,
        },
        theme: 'WHITE',
      },
    },
  },
  {
    type: 'partner',
    data: {
      title: `Un projet réussi, c'est l'art de bien s'entourer.`,
      cta: {
        label: 'Nos partenaires',
        url: `/`,
      },
      images: [
        {
          image: {
            link: '/assets/mocks/partner/1.jpg',
            alt: 'alt text',
            title: 'image 1',
            gravity: { x: 0.5, y: 0.5, height: 345, width: 282 },
          },
          tooltip: {
            title: 'RedEdition',
            text: 'Marque française créateur de mobiliers, dont le design mêle des références classiques à des codes contemporains.',
          },
        },
        {
          image: {
            link: '/assets/mocks/partner/2.jpg',
            alt: 'alt text',
            title: 'image 2',
            gravity: { x: 0.5, y: 0.5, height: 180, width: 282 },
          },
          tooltip: {
            title: 'RedEdition 2',
            text: 'Marque française créateur de mobiliers, dont le design mêle des références classiques à des codes contemporains.',
          },
        },
        {
          image: {
            link: '/assets/mocks/partner/3.jpg',
            alt: 'alt text',
            title: 'image 3',
            gravity: { x: 0.5, y: 0.5, height: 345, width: 282 },
          },
          tooltip: {
            title: 'RedEdition 3',
            text: 'Marque française créateur de mobiliers, dont le design mêle des références classiques à des codes contemporains.',
          },
        },
        {
          image: {
            link: '/assets/mocks/partner/4.jpg',
            alt: 'alt text',
            title: 'image 4',
            gravity: { x: 0.5, y: 0.5, height: 345, width: 282 },
          },
          tooltip: {
            title: 'RedEdition 4',
            text: 'Marque française créateur de mobiliers, dont le design mêle des références classiques à des codes contemporains.',
          },
        },
        {
          image: {
            link: '/assets/mocks/partner/5.jpg',
            alt: 'alt text',
            title: 'image 5',
            gravity: { x: 0.5, y: 0.5, height: 220, width: 180 },
          },
          tooltip: {
            title: 'RedEdition 5',
            text: 'Marque française créateur de mobiliers, dont le design mêle des références classiques à des codes contemporains.',
          },
        },
        {
          image: {
            link: '/assets/mocks/partner/6.jpg',
            alt: 'alt text',
            title: 'image 6',
            gravity: { x: 0.5, y: 0.5, height: 180, width: 282 },
          },
          tooltip: {
            title: 'RedEdition 6',
            text: 'Marque française créateur de mobiliers, dont le design mêle des références classiques à des codes contemporains.',
          },
        },
      ],
    },
  },
  {
    type: 'cta',
    data: {
      layout: 'cta_layout2',
      data: {
        cta: {
          label: 'Prenez rendez-vous',
          url: '/',
        },
        keepImageSize: false,
        title: 'Parlons de votre projet !',
        text: `Nous serons à vos côtés pour vous surprendre et révéler tout le potentiel de chacune des pièces que vous nous confierez.`,
        image: {
          link: '/assets/mocks/cta-layout-2/1.jpg',
          alt: 'alt text',
          title: 'image 1',
          gravity: { x: 0.5, y: 0.5, height: 660, width: 588 },
        },
        imagePosition: 'right',
      },
    },
  },
  {
    type: 'cta',
    data: {
      layout: 'cta_layout1',
      data: {
        text: `Rejoignez Perene, la 1ère enseigne d'agencement et de décoration d'intérieurs.`,
        title: `Envie d'ouvrir une boutique Perene ?`,
        cta: {
          label: 'En savoir plus',
          url: '/',
        },
        theme: 'RED',
      },
    },
  },
];

export const homeSchema: Page = {
  type: 'Homepage',
  config: {
    header: { id: 'menu-header-b2c', theme: 'WHITE' },
    footer: { id: 'menu-footer-b2c', theme: 'BLUE' },
    seo: {
      title: 'Perene - Accueil',
      description: 'Accueil description',
      keywords: 'Accueil mot clé',
    },
    breadcrumb: [
      {
        title: 'Accueil',
        url: `/${RoutesPath.HOME}`,
      },
    ],
  },
  block,
};
